import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-shot-line-plot',
    templateUrl: './shot-line-plot.component.html',
    styleUrls: ['./shot-line-plot.component.css'],
    standalone: false
})
export class ShotLinePlotComponent implements OnInit{
  @Input() shots!: any[];
  
  
  ngOnInit(): void {
    console.log('on init', this.shots)
  }
}
